import styled from 'styled-components/macro';

export const HiddenElementForCapture = styled.div`
  position: fixed;
  top: 0;
  left: -1000vw;
`;
